import { Model } from "./model";
import { uploadTestLocations } from "./caf2/uploadTestLocations";
import {NestedModel} from "./nestedmodel";

export class Caf2 extends Model {
    constructor(attributes) {
        super(Object.assign({}, attributes))
        this.uploadTestLocations = new uploadTestLocations();
        this.generatedPmmReports = new NestedModel({value: 'generatedPmmReports', parent: this});
    }

    urlRoot() {
        return '/caf-II';
    }

    url() {
        return this.urlRoot();
    }
}
